import { capitalize } from 'lodash';
import haTrack from './haTrack';

const Track = {
  page,
  event,
  timing,
};

function page(options) {
  const { title, path } = options;
  haTrack('Page View', { title, path });
}

function event(options) {
  const { category, action, label, value } = options;
  const name = [category, action].map(capitalize).join(' ');
  haTrack(name, { label, value });
}

async function timing(name, options, callback) {
  const start = performance.now();
  const result = await callback();
  const end = performance.now();
  haTrack(name, { timing: end - start, ...options });
  return result;
}

export default Track;
